import "./ParamResultat.css";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Pager from "components/ui/controls/pager/pager";
import ParamImpotSocietePageModal from "pages/audit complet/situation professionnelle/modules/parametre impot societe modal";
import Button from "components/ui/controls/button/button";
import CompactFinancialCard, { CompactFinancialContainer } from "../../AuditRemuneration/Resultat/CompactFinancialCard";
import { FaCalculator, FaSync, FaChartLine, FaCoins, FaChartBar, FaUniversity, FaMoneyBillWave, FaPiggyBank, FaPercentage, FaUsers, FaCogs } from "react-icons/fa";
import { CalculResultatEntreprise } from "components/app/Api/Remuneration/ApiRemuneration";
import { createStyledButton } from "components/ui/controls/button/button-styles";

function ParamResultat(props) {
  const context = useContext(AppContext);
  const [modalParamIS, setmodalParamIS] = useState(false);
  useEffect(() => {
    if (context.state.SetSeuilAssuj === false) {
      CalculResultatEntreprise(context.state, "").then((ResultatEntreprise) => {
        context.handleValueChange("SeuilAssuj", ResultatEntreprise.SeuilAssuj);
      });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.state.SetSeuilAssuj, context.state.ResAvtIs]);
  useEffect(() => {
    if (context.state.SetSeuilAssujConjoint === false) {
      CalculResultatEntreprise(context.state, "").then((ResultatEntreprise) => {
        context.handleValueChange("SeuilAssujConjoint", ResultatEntreprise.SeuilAssujConjoint);
      });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.state.SetSeuilAssujConjoint, context.state.ResAvtIs]);
  return (
    <>
      <Pager
        pages={[
          {
            content: (
              <>
                <div className="param-resultat-container">
                  <Column pad fill>
                    <CardBox style={{ width: "100%", maxWidth: "none" }}>
                      <Column fill>
                        <Row tpad>
                          <CompactFinancialContainer title="Paramétrage du résultat">
                            {/* Résultat avant IS */}
                            <CompactFinancialCard
                              icon={<FaChartBar />}
                              title="Résultat avant IS"
                              value={context.state.ResAvtIs}
                              accentColor="#2563eb"
                              isEditable={true}
                              onChange={(e) => {
                                context.handleCalculResultatEntreprise("", "ResAvtIs", e);
                              }}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                            {/* Impôt sur les sociétés avec bouton modal */}
                            <CompactFinancialCard
                              icon={<FaUniversity />}
                              title="Impôt sur les sociétés"
                              value={context.state.ImpotSoc}
                              accentColor="#dc2626"
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                              onEdit={() => setmodalParamIS(true)}
                            />
                            {/* Résultat net */}
                            <CompactFinancialCard
                              icon={<FaMoneyBillWave />}
                              title="Résultat net"
                              value={context.state.ResNet}
                              accentColor="#059669"
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                            {/* Mise en réserve */}
                            <CompactFinancialCard
                              icon={<FaPiggyBank />}
                              title="Mise en réserve"
                              value={context.state.Reserve}
                              accentColor="#7c3aed"
                              isEditable={true}
                              onChange={(e) => {
                                context.handleCalculResultatEntreprise("", "Reserve", e);
                              }}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                            {/* Dividendes bruts */}
                            <CompactFinancialCard
                              icon={<FaPercentage />}
                              title={context.state.InclureConjoint ? "Dividendes bruts du couple" : `Dividendes bruts pour ${context.state.Prenom}`}
                              value={context.state.DividendeBrut}
                              accentColor="#ea580c"
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                            {/* Autres associés */}
                            <CompactFinancialCard
                              icon={<FaUsers />}
                              title="Autres associés"
                              value={context.state.DividendeBrutAutres}
                              accentColor="#6b7280"
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                          </CompactFinancialContainer>
                        </Row>
                        <Row tpad>
                          <CompactFinancialContainer title="Régime social des dividendes">
                            <Row >
                              <div
                                style={{
                                  backgroundColor: "white",
                                  border: "1px solid #e5e7eb",
                                  borderRadius: "12px",
                                  padding: "16px",
                                  width: "100%",
                                  minHeight: "96px",
                                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                                  marginBottom: "12px",
                                }}
                              >
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                    <div
                                      style={{
                                        width: "48px",
                                        height: "48px",
                                        borderRadius: "50%",
                                        backgroundColor: "#dbeafe",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <FaCalculator style={{ fontSize: "16px", color: "#3b82f6" }} />
                                    </div>
                                    <div>
                                      <div style={{ fontSize: "12px", fontWeight: "600", color: "#1f2937", marginBottom: "2px" }}>Seuil d'assujetissement pour {props.Prenom}</div>
                                      <div style={{ fontSize: "12px", color: "#6b7280" }}>{context.state.SetSeuilAssuj === false ? "Calculé automatiquement" : "Saisi manuellement"}</div>
                                    </div>
                                  </div>
                                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    <Button
                                      tabIndex="-1"
                                      icon
                                      onClick={() => context.handleValueChange("SetSeuilAssuj", false)}
                                      {...createStyledButton("card-action", "cardEdit", { backgroundColor: "#dbeafe" })}
                                    >
                                      {context.state.SetSeuilAssuj === false ? (
                                        <FaCalculator style={{ color: "#3b82f6", fontSize: "12px" }} />
                                      ) : (
                                        <FaSync style={{ color: "#3b82f6", fontSize: "12px" }} />
                                      )}
                                    </Button>
                                    <TextField
                                      value={context.state.SeuilAssuj}
                                      onChange={(e) => {
                                        context.handleValueChange("SetSeuilAssuj", true);
                                        context.handleValueChange("SeuilAssuj", e.target.value);
                                      }}
                                      dataType="uint"
                                      format={{ thousands: " ", unit: " €" }}
                                      small
                                      style={{ minWidth: "80px",fontSize: "12px" }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </Row>

                            {/* Seuil d'assujetissement conjoint */}
                            {context.state.InclureConjoint && context.state.StatutConjoint === "TNS Article 62" && (
                              <>
                              <Row >
                              <div
                                style={{
                                  backgroundColor: "white",
                                  border: "1px solid #e5e7eb",
                                  borderRadius: "12px",
                                  padding: "16px",
                                  width: "100%",
                                  minHeight: "96px",
                                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                                  marginBottom: "12px",
                                }}
                              >
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                    <div
                                      style={{
                                        width: "48px",
                                        height: "48px",
                                        borderRadius: "50%",
                                        backgroundColor: "#dbeafe",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <FaCalculator style={{ fontSize: "16px", color: "#3b82f6" }} />
                                    </div>
                                    <div>
                                      <div style={{ fontSize: "12px", fontWeight: "600", color: "#1f2937", marginBottom: "2px" }}>Seuil d'assujetissement pour {context.state.PrenomConjoint}</div>
                                      <div style={{ fontSize: "12px", color: "#6b7280" }}>{context.state.SetSeuilAssujConjoint === false ? "Calculé automatiquement" : "Saisi manuellement"}</div>
                                    </div>
                                  </div>
                                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    <Button
                                      tabIndex="-1"
                                      icon
                                      onClick={() => context.handleValueChange("SetSeuilAssujConjoint", false)}
                                      {...createStyledButton("card-action", "cardEdit", { backgroundColor: "#dbeafe" })}
                                    >
                                      {context.state.SetSeuilAssujConjoint === false ? (
                                        <FaCalculator style={{ color: "#3b82f6", fontSize: "12px" }} />
                                      ) : (
                                        <FaSync style={{ color: "#3b82f6", fontSize: "12px" }} />
                                      )}
                                    </Button>
                                    <TextField
                                      value={context.state.SeuilAssujConjoint}
                                      onChange={(e) => {
                                        context.handleValueChange("SetSeuilAssujConjoint", true);
                                        context.handleValueChange("SeuilAssujConjoint", e.target.value);
                                      }}
                                      dataType="uint"
                                      format={{ thousands: " ", unit: " €" }}
                                      small
                                      style={{ minWidth: "80px",fontSize: "12px" }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </Row>
                              </>
                            )}
                          </CompactFinancialContainer>
                        </Row>
                      </Column>
                    </CardBox>
                  </Column>
                </div>
                <ParamImpotSocietePageModal visible={modalParamIS} onClose={() => setmodalParamIS(false)} />
              </>
            ),
          },
        ]}
        page={0}
        navButtons={{
          validate: {
            onClick: () => {
              props.onClose();
            },
          },
        }}
      />
    </>
  );
}

export default ParamResultat;
